var styles = {
  "KeyboardNavigationOption": "Online-Store-UI-KeyboardNavigationOption_1rjhb",
  "selected": "Online-Store-UI-KeyboardNavigationOption--selected_vi7dn",
  "cover": "Online-Store-UI-KeyboardNavigationOption--cover_hs998"
};

export { styles as default };
